import React from 'react';
import ContentLoader from 'react-content-loader';
import NumberFormat from 'react-number-format';
import { useHistory, withRouter } from 'react-router-dom';
import { Button, Grid, Page, Tabs, Tab, Form } from 'tabler-react';

import PrivatePage from './PrivatePage';
import { UseDebounce } from '../components';
import { Backend } from '../services';

function ProjectAccreditationPage(props) {
  const projectId = props.match.params.projectId;

  const history = useHistory();
  const [project, setProject] = React.useState(null);
  const [pageData, setPageData] = React.useState(null);
  const [lots, setLots] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  const [filterOptions, setFilterOptions] = React.useState(null);
  const [filterArea, setFilterArea] = React.useState(null);
  const [filterBlocks, setFilterBlocks] = React.useState(null);
  const [filterPrice, setFilterPrice] = React.useState(null);
  const [filterStatus, setFilterStatus] = React.useState({'À VENDA': true});

  const [refreshLots, setRefreshLots] = React.useState(0);
  const debouncedRefreshLots = UseDebounce(refreshLots, 500);

  React.useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const resProject = await Backend.getProject(projectId);
        setProject(resProject.data);

        const resPageData = await Backend.getProjectPageDataFull(projectId);
        setPageData(resPageData.data);

        const resFilter = await Backend.getProjectLotFilterOptions(projectId);
        setFilterOptions(resFilter.data);
        setFilterArea(resFilter.data.maximumArea);
        setFilterBlocks(resFilter.data.blocks.reduce((obj, block) => ({...obj, [block]: false}), {}));
        setFilterPrice(resFilter.data.maximumPrice);
        setFilterStatus({...resFilter.data.status.reduce((obj, s) => ({...obj, [s]: false}), {}), ...filterStatus});

        await fetchLots();

        setLoading(false);
      } catch (err) {
        console.error(err);
        alert('Something went wrong');
      }

      setLoading(false);
    })();
  }, []);

  React.useEffect(() => {
    (async() => {
      if (!lots) return;

      setRefreshLots(refreshLots + 1);
    })();
  }, [filterArea, filterBlocks, filterPrice, filterStatus]);

  React.useEffect(() => {
    (async() => {
      if (refreshLots === 0) return;

      await fetchLots();
    })();
  }, [debouncedRefreshLots]);

  const fetchLots = async () => {
    try {
      setLots(null);

      const res = await Backend.listProjectLots(projectId, {
        blocks: Object.keys(filterBlocks || {}).filter(b => filterBlocks[b]).join(';'),
        maximumArea: filterArea,
        maximumPrice: filterPrice,
        status: Object.keys(filterStatus || {}).filter(s => filterStatus[s]).join(';'),
      });
      
      setLots(res.data.rows);
    } catch (err) {
      console.error(err);
      alert('Something went wrong');
    }
  };

  const generateYoutubeEmbedUrl = (youtubePlaylistUrl) => {
    const YOUTUBE_PLAYLIST_ID_REGEX = /\?list=([\w]+)\&?/
    const matches = YOUTUBE_PLAYLIST_ID_REGEX.exec(youtubePlaylistUrl);
    const playlistId = matches && matches.length > 1 ? matches[1] : null;

    return `https://www.youtube.com/embed/videoseries?list=${playlistId}&enablejsapi=1&wmode=opaque`
  }


  const renderLotsFilterOptions = () => (
    <Grid.Row>
      <Grid.Col sm="12" lg="6">
        <Form.Group label="Status">
        {
          !filterStatus ? null :
          Object.keys(filterStatus).sort((a, b) => a.localeCompare(b)).map(status => (
            <Form.Checkbox
              key={status}
              isInline
              checked={filterStatus[status]}
              label={status}
              value="true"
              onChange={(e) => setFilterStatus({...filterStatus, ...{[status]: e.target.checked}})}
            />
          ))
        }
        </Form.Group>
      </Grid.Col>

      <Grid.Col sm="12" lg="6">
        <Form.Group label="Área Máxima">
        { !filterArea ? null :
          <Form.Ratio
            className="custom-ratio"
            max={filterOptions.maximumArea/100}
            min={filterOptions.minimumArea/100}
            step={1}
            value={filterArea/100}
            onChange={(e) => setFilterArea(e.target.value * 100)}
          />
        }
        </Form.Group>
      </Grid.Col>

      <Grid.Col sm="12" lg="6">
        <Form.Group label="Blocos">
        {
          !filterBlocks ? null :
          Object.keys(filterBlocks).sort().map(block => (
            <Form.Checkbox
              key={block}
              isInline
              checked={filterBlocks[block]}
              label={block}
              value="true"
              onChange={(e) => setFilterBlocks({...filterBlocks, ...{[block]: e.target.checked}})}
            />
          ))
        }
        </Form.Group>
      </Grid.Col>

      <Grid.Col sm="12" lg="6">
        <Form.Group label="Preço Máximo">
        { !filterPrice ? null :
          <Form.Ratio
            className="custom-ratio"
            max={filterOptions.maximumPrice/100}
            min={filterOptions.minimumPrice/100}
            step={1000}
            value={filterPrice/100}
            onChange={(e) => setFilterPrice(e.target.value * 100)}
          />
        }
        </Form.Group>
      </Grid.Col>
    </Grid.Row>
  )

  const renderLot = (item) => (
    <div className="card">
      <div className="d-flex justify-content-between m-3" style={{borderBottom: '1px solid #DDD'}}>
        <div>
          <div className="primary-color" style={{fontSize: '18px', fontWeight: 800}}>{item.identifier}</div>
          <small className="d-block text-muted">
          { item.kind ?  item.kind : (
            project.kind === 'residential' ? 'Residencial' : (
              project.kind === 'business' ? 'Empresarial' : (
                project.kind === 'area' ? 'Área': (
                  project.kind === 'mixed' ? 'Misto': ''
                )
              )   
            )
          )}
          </small>
        </div>
        <div className="text-muted text-right d-flex flex-column">
          <span className={`${item.status === 'À VENDA' ? 'green-color' : (item.status === 'VENDIDO' ? 'red-color' : (item.status === 'RESERVADO' ? 'yellow-color' : ''))}`}>{item.status}</span>
        </div>
      </div>
      <div className="px-3 pb-3" style={{fontSize: '14px'}}>
        <div className="d-flex justify-content-between py-1">
          <span>Área Real (m²)</span>
          <NumberFormat
            value={item.area/100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            renderText={value => <span style={{textAlign: 'right'}}>{value}</span>}/>
        </div>

        <div className="d-flex justify-content-between py-1">
          <span>Preço Final do Lote (R$/m²)</span>
          <NumberFormat
            value={item.areaPrice/100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            renderText={value => <span style={{textAlign: 'right'}}>{value}</span>}/>
        </div>
          
         
        <div className="d-flex justify-content-between py-1">
          <span>Valor Final do Lote</span>
          <NumberFormat
            value={item.finalPrice/100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            prefix="R$ "
            renderText={value => <span style={{textAlign: 'right', fontWeight: 700}}>{value}</span>}/>
        </div>
      </div>
      {
        !project.simulatorEnabled ? null :
        <div className="d-flex justify-content-between mx-3 mb-1" style={{borderTop: '1px solid #DDD'}}>
          <div></div>
          <div className="text-right">
            <Button link className="px-0" onClick={() => history.push(`/projects/${project.id}/simulation/${item.id}`)}>Simular</Button>
          </div>
        </div>
      }
    </div>
  );

  return (
    <PrivatePage>
      {
        loading ? <Page.Content><ContentLoader foregroundColor="#DDD"/></Page.Content>
        :
        <div className="page-content">
          <div className="container">
            <div className="card">
              <div style={{
                width: '100%',
                height: '152px',
                backgroundSize: 'contain',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#EEF0F2',
                backgroundImage: `url('${Backend.generateProjectImageUrl(project.id, project.images.find(i => i.kind === 'banner')?.id)}')`}}>
              </div>
            </div>
            <Tabs initialTab="Lotes">
              <Tab title='Lotes'>
                { renderLotsFilterOptions() }
                <Grid.Row className="row-cards">
                {   
                  lots?.map(lot => (
                    <Grid.Col xs={12} sm={12} md={6} lg={4} key={lot.id}>
                      { renderLot(lot) }
                    </Grid.Col>
                  ))
                }
                </Grid.Row>
              </Tab>

              <Tab title='Informações'>
                <div className="card px-4 py-2">
                <Tabs initialTab={pageData?.index?.length > 0 ? pageData?.index[0]: ''}>
                  {
                    pageData?.index?.map((page) => (
                      <Tab title={page} key={page}>
                        <div dangerouslySetInnerHTML={{__html: pageData.content[page]?.replace('href="', 'target="_blank" href="')}}></div>
                      </Tab>
                    ))
                  }
                </Tabs>
                </div>
              </Tab>
                
                <Tab title='Mapa'>
                  {
                    project.mapEnabled ?
                    <iframe src={Backend.generateProjectMapUrl(project.id)} width="100%" height="600px" z="28" frameborder="0"></iframe>
                    :
                    <p>Mapa desabilitado</p>
                  }
                </Tab>

              <Tab title='Fotos'>
                <Grid.Row className="row-cards">
                {
                  project?.images?.filter(image => image.kind === 'picture').map(image => (
                    <Grid.Col xs={12} sm={12} md={6} lg={4} key={image.id}>
                      <img src={Backend.generateProjectImageUrl(project.id, image.id)}></img>
                    </Grid.Col>
                  ))
                }
                </Grid.Row>
              </Tab>

              <Tab title='Vídeos'>
                <iframe width="100%" height="650" src={generateYoutubeEmbedUrl(project.youtubePlaylistUrl)} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="">
                </iframe>
              </Tab>
            </Tabs>
          </div>
        </div>
      }
    </PrivatePage>
  )
}

export default withRouter(ProjectAccreditationPage);